{
  "seo": {
    "homeTitle": "French Riviera: Things to Do, Events & Tours — Riviera To-Do",
    "homeDescription": "Things to do on the French Riviera: concerts and shows, day trips, wine tastings and boat rentals in Nice, Cannes, Monaco, Antibes and Saint-Tropez.",
    "homeImageAlt": "Èze and the coast of the French Riviera at sunset",
    "toursTitle": "French Riviera Tours, Day Trips & Excursions — Riviera To-Do",
    "toursDescription": "Tours and day trips on the French Riviera from Nice, Cannes, Monaco and Antibes: Èze and Monaco, Provence villages, wine tastings, boat trips and private tours.",
    "eventsTitle": "Events on the French Riviera — Riviera To-Do",
    "eventsDescription": "Concerts, exhibitions, theatre and festivals across Nice, Cannes, Monaco and the French Riviera — with tickets and dates.",
    "articlesTitle": "French Riviera Travel Guide — Articles & Tips",
    "articlesDescription": "French Riviera travel guide: festivals by season, local wine and food, yachts and beaches, day trips and practical tips for Nice, Cannes, Monaco and beyond.",
    "citiesTitle": "Cities of the French Riviera — Riviera To-Do",
    "citiesDescription": "Nice, Cannes, Monaco, Antibes, Saint-Tropez, Menton and Villefranche-sur-Mer — explore events, tours and things to do in each Riviera city.",
    "boatsTitle": "Boat & Yacht Rental on the French Riviera — Riviera To-Do",
    "boatsDescription": "Rent a motorboat, RIB, yacht, sailboat or catamaran on the French Riviera — with a skipper or without, from Cannes, Antibes, Saint-Tropez, Nice and Monaco."
  },
  "app": {
    "logIn": "Log in"
  },
  "nav": {
    "events": "Events",
    "tours": "Tours",
    "wineTours": "Wine Tours",
    "boats": "Yachts & Boats",
    "hotels": "Hotels",
    "articles": "Articles",
    "cities": "Cities"
  },
  "a11y": {
    "language": "Language",
    "favorites": "Favorites",
    "menu": "Menu",
    "closeMenu": "Close menu",
    "home": "Go to home page",
    "back": "Back",
    "previous": "Previous",
    "next": "Next",
    "addFavorite": "Add to favorites",
    "removeFavorite": "Remove from favorites"
  },
  "common": {
    "seeAll": "See all",
    "wholeRegion": "Whole region",
    "allCategories": "All categories",
    "fromPrice": "from {{price}}",
    "inCity": " in {{city}}",
    "notFound": "Page not found.",
    "home": "Home",
    "showMore": "Show more",
    "loadingMore": "Loading…",
    "loadMoreError": "Couldn't load more. Please try again."
  },
  "dates": {
    "today": "today",
    "tomorrow": "tomorrow",
    "thisWeekend": "this weekend",
    "on": "on {{date}}"
  },
  "filters": {
    "chooseCity": "Choose a city",
    "filterByDate": "Filter by date",
    "showAllEvents": "Show all events",
    "resetFilters": "Reset filters"
  },
  "dateFilters": {
    "alltime": "All time",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "weekend": "This weekend",
    "custom": "Pick a date"
  },
  "categories": {
    "concerts": "Concerts",
    "theatre": "Theatre",
    "exhibitions": "Exhibitions",
    "parties": "Parties",
    "gastronomy": "Gastronomy",
    "festivals": "Festivals",
    "sport": "Sport",
    "family": "Family",
    "cinema": "Cinema",
    "other": "Other"
  },
  "categoryLabels": {
    "concerts": "Concert",
    "exhibitions": "Exhibition",
    "parties": "Party",
    "theatre": "Theatre",
    "gastronomy": "Gastronomy",
    "festivals": "Festival",
    "sport": "Sport",
    "family": "Family",
    "cinema": "Cinema",
    "other": "Other",
    "fallback": "Event"
  },
  "categoryNouns": {
    "all": "events",
    "concerts": "concerts",
    "theatre": "theatre",
    "exhibitions": "exhibitions",
    "parties": "parties",
    "gastronomy": "gastronomy events",
    "festivals": "festivals",
    "sport": "sport events",
    "family": "family events",
    "cinema": "cinema",
    "other": "events"
  },
  "home": {
    "heroTitle": "The French Riviera",
    "heroSubtitle": "All the Riviera's events in one place",
    "findEvents": "Find events",
    "statCities_one": "{{count}} city",
    "statCities_other": "{{count}} cities",
    "statCategories_one": "{{count}} category",
    "statCategories_other": "{{count}} categories",
    "eventsNoun_one": "event",
    "eventsNoun_other": "events"
  },
  "cityHero": {
    "events_one": "{{display}} event",
    "events_other": "{{display}} events",
    "tours_one": "{{display}} tour",
    "tours_other": "{{display}} tours",
    "boats_one": "{{display}} boat",
    "boats_other": "{{display}} boats"
  },
  "events": {
    "heading": "Top {{noun}}{{where}}{{when}}",
    "loading": "Loading events…",
    "empty": "No events found.",
    "aboutEvent": "About this event",
    "moreUpcomingCity": "More upcoming events in {{city}}",
    "moreUpcoming": "More upcoming events",
    "getTickets": "Get tickets",
    "free": "Free",
    "loadingOne": "Loading event…",
    "loadError": "Couldn't load event: {{error}}",
    "notFound": "Event not found.",
    "attributionFnac": "Ticketing by Fnac Spectacles.",
    "headingRegion": "What's on across the French Riviera",
    "headingCity": "What's on in {{city}}",
    "subheading": "Concerts, exhibitions, theatre and festivals — with dates and tickets.",
    "endedBanner": "This event has ended",
    "endedHint": "Check out the upcoming events below.",
    "datesHeading": "Dates & tickets",
    "tickets": "Tickets",
    "moreDates_one": "+{{count}} more date",
    "moreDates_other": "+{{count}} more dates",
    "showAllDates": "Show all dates ({{count}})",
    "showFewerDates": "Show fewer dates",
    "moved": "This event page has moved.",
    "movedLink": "Go to the event page"
  },
  "tours": {
    "headingRegion": "French Riviera tours & day trips",
    "headingCity": "Tours & experiences in {{city}}",
    "subheading": "Handpicked experiences, tours and day trips — booked on Viator.",
    "loading": "Loading experiences…",
    "empty": "No experiences found.",
    "badge": "Experience",
    "viaViator": "via Viator",
    "book": "Book",
    "aboutExperience": "About this experience",
    "moreInCity": "More tours in {{city}}",
    "more": "More tours",
    "moreWineInCity": "More wine tours in {{city}}",
    "moreWine": "More wine tours",
    "perPerson": "per person",
    "reviews_one": "{{count}} review",
    "reviews_other": "{{count}} reviews",
    "loadingOne": "Loading experience…",
    "loadError": "Couldn't load experience: {{error}}",
    "notFound": "Experience not found.",
    "delistedBanner": "This experience is no longer available",
    "delistedHint": "It can no longer be booked. See other experiences below."
  },
  "boats": {
    "headingRegion": "Boat & yacht rental on the French Riviera",
    "headingCity": "Yacht & boat rentals in {{city}}",
    "subheading": "Motorboats, sailboats and yachts — book directly with Click&Boat.",
    "loading": "Loading boats…",
    "empty": "No boats found.",
    "emptyInCity": "No boats found in {{city}}.",
    "badge": "Boat rental",
    "viaClickAndBoat": "via Click&Boat",
    "book": "Book",
    "aboutBoat": "About this boat",
    "moreInCity": "More boats in {{city}}",
    "more": "More boats",
    "perDay": "per day",
    "loadingOne": "Loading boat…",
    "loadError": "Couldn't load boat: {{error}}",
    "notFound": "Boat not found.",
    "delistedBanner": "This boat is no longer available",
    "delistedHint": "It can no longer be booked. See other boats below.",
    "faqHeading": "Boat rental on the French Riviera: frequently asked questions",
    "facts": {
      "heading": "Boat details",
      "type": "Boat type",
      "port": "Departure port",
      "price": "Price",
      "rating": "Rating",
      "year": "Build year",
      "owner": "Owner",
      "rentalBasis": "Rental basis",
      "rentalBasisValue": "Per day",
      "skipper": "Skipper option",
      "skipperValue": "With or without a skipper",
      "passengers": "Passengers",
      "passengersValue": "Up to {{value}}",
      "length": "Length",
      "lengthValue": "{{value}} m",
      "cabins": "Cabins",
      "berths": "Berths",
      "bathrooms": "Bathrooms",
      "engine": "Engine",
      "engineValue": "{{value}} hp",
      "licence": "Boat licence",
      "licenceRequired": "Required",
      "licenceNotRequired": "Not required",
      "skipperIncluded": "Skipper included",
      "skipperNotAvailable": "Without a skipper",
      "onBoard": "On board"
    },
    "typeLabel": {
      "Motorboat": "Motorboat",
      "Sailboat": "Sailboat",
      "Catamaran": "Catamaran",
      "RIB": "RIB",
      "Motor yacht": "Motor yacht",
      "Houseboat": "Houseboat",
      "Boat without licence": "Boat without a licence",
      "Jet ski": "Jet ski",
      "Sailing yacht": "Sailing yacht"
    },
    "ownerLabel": {
      "professional": "Professional",
      "private": "Private owner"
    },
    "template": {
      "title": "{{type}} rental in {{city}} — {{name}}",
      "description": "{{name}} is a {{type}} available to rent in {{city}} on the French Riviera, from €{{price}} per day, with or without a skipper.",
      "summary": "{{type}} rental in {{city}} from €{{price}}/day — {{name}} on the French Riviera.",
      "priceSuffix": "From €{{price}}/day."
    },
    "cityIntro": {
      "nice": "Nice's boat rentals are based around Nice Port and the Baie des Anges, with easy access to the calm waters stretching toward Cap d'Antibes and the Italian border. Motorboats and RIBs are the most common choice for a day on the water, ideal for exploring nearby Villefranche-sur-Mer or the Lérins Islands. Summer (June–September) brings the calmest seas and warmest swimming, though spring and early autumn avoid the peak-season crowds around the bay.",
      "cannes": "Cannes rents from two main points — the Vieux Port beneath the Palais des Festivals, and nearby Mandelieu-la-Napoule — putting the pine-covered Lérins Islands within a short crossing. Motor yachts and motorboats dominate the fleet here, reflecting the city's glamorous reputation, alongside plenty of family-friendly RIBs. May and June are busiest with festival season, while July and August offer the most reliably calm Mediterranean conditions for a full day afloat.",
      "antibes": "Antibes and neighbouring Golfe-Juan and Juan-les-Pins form one of the Riviera's busiest boating hubs, anchored by Port Vauban, one of Europe's largest marinas. Sailboats and motorboats are both well represented, suited to short hops along Cap d'Antibes or longer runs toward the Lérins Islands. The bay's relatively sheltered waters make it a forgiving spot for first-time renters going out without a skipper.",
      "villefranche": "Villefranche-sur-Mer's deep, sheltered bay — one of the calmest natural harbours on the coast — makes it a favourite launch point for boats headed toward Cap Ferrat, Beaulieu-sur-Mer and the Italian border. RIBs and motorboats suit the short, scenic routes around the cape best. The bay's depth keeps conditions calm even when the open water further out gets choppy, a plus for less experienced renters.",
      "monaco": "Monaco's boat rentals depart from the principality itself or the neighbouring ports of Cap-d'Ail and Monte-Carlo, putting Menton and the Italian Riviera within easy reach along the coast. The fleet here leans upmarket, with motor yachts alongside motorboats, matching Monaco's reputation as a superyacht harbour. Calm summer seas and short crossing distances suit both a skippered afternoon and a longer self-piloted day.",
      "menton": "Menton, the Riviera's easternmost town, offers a quieter alternative to Nice or Cannes for a boat rental, with departures from the town's small harbour and neighbouring Menton-Garavan. It's a natural base for exploring the calm waters toward Monaco or crossing into nearby Italian coastal towns. The relative lack of congestion suits both first-time renters and those after an easy day without heavy marina traffic.",
      "sttropez": "Saint-Tropez and its wider bay — including Sainte-Maxime, Grimaud, Port Grimaud, Cogolin, Cavalaire-sur-Mer and Ramatuelle — form the Riviera's largest boat-rental cluster, with the widest choice of boat types, from RIBs to sailboats and motor yachts. The sheltered Gulf of Saint-Tropez keeps conditions manageable for most of the season, and Pampelonne beach and the Îles d'Hyères are popular day-trip destinations. July and August are the busiest months, so booking ahead is worthwhile."
    },
    "faq": [
      {
        "q": "Do I need a boating licence to rent a boat?",
        "a": "Not always. Many boats on Click&Boat can be rented with a skipper included, so no licence is required — look for the \"with skipper\" option on each listing. Renting without a skipper (bareboat) generally requires a valid boating licence matching the boat's size and engine power."
      },
      {
        "q": "Is a deposit or insurance required?",
        "a": "Yes. Click&Boat requires a security deposit for most rentals, and every booking includes liability insurance covering the boat and passengers during the rental period. Deposit amounts and insurance terms vary by boat and are shown on each listing before you book."
      },
      {
        "q": "What's included in the price?",
        "a": "The listed day rate typically covers the boat itself and basic safety equipment. Fuel, a skipper (if selected), and any extras are usually priced separately — check the specific listing on Click&Boat for exactly what's included before booking."
      },
      {
        "q": "Can I cancel or change my booking?",
        "a": "Cancellation policies are set by each boat owner and shown at checkout on Click&Boat before you pay. Many listings offer free cancellation up to a set number of days before departure — review the terms on your chosen boat's page."
      },
      {
        "q": "When is the boating season on the French Riviera?",
        "a": "Most boats are available from spring to autumn, with the peak in July and August — book early for those weeks. Many owners also rent in May, June and September, when the coves and anchorages are quieter."
      }
    ],
    "equipment": {
      "air_conditioning": "Air conditioning",
      "generator": "Generator",
      "bimini": "Bimini sun awning",
      "sun_pads": "Sun pads",
      "swim_platform": "Swim platform",
      "swim_ladder": "Swim ladder",
      "deck_shower": "Deck shower",
      "toilet": "Toilet",
      "kitchen": "Galley",
      "fridge": "Fridge",
      "sound_system": "Sound system",
      "tv": "TV",
      "wifi": "Wi-Fi",
      "gps": "GPS",
      "autopilot": "Autopilot",
      "bow_thruster": "Bow thruster",
      "anchor_windlass": "Anchor windlass",
      "tender": "Tender",
      "paddle_board": "Paddle board",
      "snorkelling_gear": "Snorkelling gear",
      "kayak": "Kayak",
      "water_skis": "Water skis",
      "wakeboard": "Wakeboard",
      "towable": "Towable ring",
      "seabob": "Underwater scooter",
      "fishing_gear": "Fishing gear"
    }
  },
  "crossSell": {
    "headingCity": "Tours & boat rental {{inCity}}",
    "heading": "Tours & boat rental on the French Riviera"
  },
  "hotels": {
    "eventHeading": "Staying the night?",
    "nearVenue": "Hotels near {{venue}}",
    "inCity": "Hotels {{inCity}}",
    "dates": "{{checkin}} → {{checkout}}",
    "cta": "See hotels",
    "ctaCity": "See hotels {{inCity}}",
    "showMap": "Show hotels on the map",
    "hideMap": "Hide the map",
    "mapTitle": "Map of hotels nearby",
    "sectionHeading": "Where to stay {{inCity}}",
    "sectionText": "Hotels, apartments and guesthouses {{inCity}}, with prices for your dates across the main booking sites."
  },
  "articles": {
    "latest": "Latest articles",
    "loading": "Loading articles…",
    "loadError": "Couldn't load articles: {{error}}",
    "badge": "Article",
    "readArticle": "Read article",
    "loadingOne": "Loading article…",
    "loadErrorOne": "Couldn't load article: {{error}}",
    "notFound": "Article not found.",
    "headingRegion": "French Riviera travel guide",
    "subheading": "Guides, tips and stories to help you plan your trip.",
    "empty": "No articles yet.",
    "planHeading": "Plan your trip",
    "moreHeading": "More articles",
    "topics": {
      "wine": "Wine",
      "food": "Food & drink",
      "festivals": "Festivals & events",
      "seasonal": "Seasonal guides",
      "boats": "Boats & beaches",
      "tours": "Tours & day trips",
      "culture": "Culture & sights",
      "practical": "Practical tips"
    }
  },
  "citiesHub": {
    "heading": "Cities of the French Riviera",
    "intro": [
      "The French Riviera — the Côte d'Azur — runs along the Mediterranean from Saint-Tropez in the west to Menton on the Italian border. Its towns are close together, but each has its own character: Nice is the lively capital, Cannes and Monaco trade on glamour, Antibes and Villefranche-sur-Mer are smaller and slower, Saint-Tropez is the summer playground, and Menton is the calmest of all.",
      "Most of them sit on a single coastal railway, so it's easy to stay in one town and explore the rest on day trips. Pick a city below to see its upcoming events, tours and things to do."
    ],
    "taglines": {
      "nice": "The Riviera's capital: old town, museums, the airport and trains in every direction.",
      "cannes": "Film-festival glamour on La Croisette, with boat trips to the Lérins Islands.",
      "monaco": "Casino, Grand Prix and harbour superyachts in a two-square-kilometre principality.",
      "antibes": "Ramparts, the Picasso museum and Juan-les-Pins' summer jazz festival.",
      "sttropez": "Old-port chic, Pampelonne's beach clubs and rosé vineyards all around.",
      "menton": "The quiet, sunny end of the coast: gardens, lemons and Italy next door.",
      "villefranche": "A small harbour village on one of the Riviera's deepest, most sheltered bays."
    },
    "faqHeading": "French Riviera cities: frequently asked questions",
    "faq": [
      {
        "q": "Which town is the best base on the French Riviera?",
        "a": "For a first trip, Nice: it has the airport, the widest choice of hotels and restaurants, and trains along the coast to Cannes, Antibes, Villefranche-sur-Mer, Monaco and Menton. Cannes or Antibes suit travellers who want a smaller town in the west, Menton or Villefranche-sur-Mer a quieter stay in the east. Saint-Tropez is best treated as a destination in its own right rather than a base — it's off the railway and far from the airport."
      },
      {
        "q": "Can I get around the Riviera without a car?",
        "a": "Yes, for most of it. TER regional trains run along the coast from Cannes through Antibes, Nice, Villefranche-sur-Mer and Monaco to Menton and on to the Italian border, several times an hour at busy times, and local buses fill the gaps. Saint-Tropez is the exception: it has no train station, so you'll need a car, a bus from Saint-Raphaël or a boat — seasonal services also run from Nice and Cannes."
      },
      {
        "q": "How far are the towns from Nice airport?",
        "a": "Central Nice is about 25 minutes away by tram. By train from Nice, Villefranche-sur-Mer is under 10 minutes away, Antibes and Monaco around 20–25 minutes, Cannes 30–40 minutes and Menton 35–40 minutes. Saint-Tropez is roughly two hours from the airport by road, often more in summer traffic."
      },
      {
        "q": "Which town is the quietest, and which is the liveliest?",
        "a": "Menton and Villefranche-sur-Mer are the calmest — small, residential and family-friendly. Nice has the most going on year-round, with the busiest calendar of concerts, theatre and festivals. Cannes and Monaco revolve around their big events — the Film Festival in May and the Grand Prix in late spring — while Saint-Tropez and Juan-les-Pins are at their liveliest in July and August."
      },
      {
        "q": "When is the best time to visit the French Riviera?",
        "a": "Late spring (May–June) and early autumn (September–October) bring warm weather without peak-season crowds. July and August are the hottest and busiest months, when prices rise and festivals fill the calendar. Winter is mild and quiet, livened up in February by the Nice Carnival and Menton's Lemon Festival."
      }
    ],
    "imageAlt": "{{city}}, French Riviera"
  },
  "hotelsPage": {
    "heading": "Where to stay on the French Riviera",
    "seoTitle": "Where to Stay on the French Riviera: Towns & Hotel Map",
    "metaDescription": "Nice, Cannes, Monaco, Antibes, Saint-Tropez, Menton or Villefranche? Which Riviera town and neighbourhood to stay in, with a map of hotels and apartments.",
    "intro": [
      "Where you sleep shapes a trip to the French Riviera more than you might think. The coast runs from Saint-Tropez in the west to Menton on the Italian border, and each town offers something different: Nice has the widest choice and the best connections, Cannes and Monaco are the glamorous (and expensive) options, Antibes and Menton are smaller and calmer, and Villefranche-sur-Mer is a village on one of the most beautiful bays on the coast.",
      "The map below shows hotels, apartments and guesthouses across the whole Riviera, with prices from the main booking sites — pick a town to zoom in. Further down: which part of each town to stay in, and who it suits."
    ],
    "wholeRiviera": "All the Riviera",
    "showOnMap": "Show on the map",
    "townsHeading": "Which town to stay in",
    "cities": {
      "nice": {
        "name": "Nice",
        "text": "The best base for a first trip: the airport is about 25 minutes away by tram, and trains run along the coast in both directions. Stay in or next to the Old Town (Vieux-Nice) to be among the restaurants and markets — lively, but noisy on summer nights. Hotels on the Promenade des Anglais have the sea views; the streets around Avenue Jean-Médecin and Nice-Ville station are the practical, better-value choice, and the Port quarter is quieter, with a local feel."
      },
      "cannes": {
        "name": "Cannes",
        "text": "Hotels cluster along La Croisette, from the big seafront palaces to smaller places a street or two back. Le Suquet, the old quarter on the hill above the Old Port, has more character, and the area around Rue d'Antibes and the station is central and usually cheaper. During the Film Festival in May and the big trade fairs, prices soar and rooms sell out months ahead — on those dates, Antibes, Juan-les-Pins or Mandelieu-la-Napoule are good fall-backs."
      },
      "monaco": {
        "name": "Monaco",
        "text": "Monaco has only a few hotels, and they're among the most expensive on the coast, especially around the Casino in Monte-Carlo. Many visitors stay just over the border in France — in Beausoleil, a short walk uphill from Monte-Carlo, or in Cap-d'Ail — or base themselves in Nice, 20–25 minutes away by train. Book far ahead for the Grand Prix weekend, when prices rise along the whole eastern Riviera."
      },
      "antibes": {
        "name": "Antibes",
        "text": "Vieil Antibes, the old town inside the ramparts, is the place to stay for walkable streets, the Provençal market and the yachts of Port Vauban. Juan-les-Pins, on the other side of the Cap, has sandy beaches, later nights and the Jazz à Juan festival in July. The Cap d'Antibes itself is secluded and upmarket — lovely, but you'll want a car or taxis. Antibes and Juan-les-Pins both have train stations."
      },
      "sttropez": {
        "name": "Saint-Tropez",
        "text": "Hotels in the village itself are small and upmarket, and at their priciest in July and August. Pampelonne's beach clubs are a few kilometres south, in Ramatuelle, which has its own hotels and villas. For better value, stay across the gulf in Sainte-Maxime or Port Grimaud and take the shuttle boat over. There's no train: plan on a car, a bus from Saint-Raphaël or a boat."
      },
      "menton": {
        "name": "Menton",
        "text": "The calm, sunny end of the coast, and usually better value than Nice or Cannes. Hotels line the seafront promenade and the streets below the old town; Garavan, the bay towards the Italian border, is quieter still. Menton suits a relaxed stay or a long winter break, and trains reach Monaco in about 10 minutes and Nice in 35–40."
      },
      "villefranche": {
        "name": "Villefranche-sur-Mer",
        "text": "A small harbour village with only a handful of hotels, so apartments and guest rooms make up much of what's on offer. Stay near the old town and the harbour for the views over the bay, or look along the coast in Beaulieu-sur-Mer and Saint-Jean-Cap-Ferrat for more upmarket hotels. Nice is under 10 minutes away by train, Monaco about 15."
      }
    },
    "faqHeading": "Where to stay on the French Riviera: frequently asked questions",
    "faq": [
      {
        "q": "Which is the best town to stay in on the French Riviera?",
        "a": "For a first trip, Nice: it has the most hotels at every price, the airport on its doorstep and trains along the whole coast, so the other towns are easy day trips. Choose Cannes or Monaco for glamour, Antibes for a smaller town with beaches, Menton or Villefranche-sur-Mer for a quiet stay, and Saint-Tropez if the beach clubs are the point of the trip."
      },
      {
        "q": "Where can I stay on the Riviera without a car?",
        "a": "Anywhere on the coastal railway: Cannes, Antibes, Juan-les-Pins, Nice, Villefranche-sur-Mer, Monaco and Menton all have stations, with regional trains several times an hour at busy times. Pick a hotel within walking distance of a station and you can explore the whole coast without driving. Saint-Tropez is the exception — it's off the railway, so you'll need a car, a bus or a boat."
      },
      {
        "q": "When are hotels on the Riviera most expensive?",
        "a": "July and August are high season everywhere. Prices also jump around the big events: the Cannes Film Festival in May, the Monaco Grand Prix in late spring and the Nice Carnival in February — for those dates, book months ahead or stay in a neighbouring town. Spring and autumn bring lower prices and warm weather, and winter is the cheapest time of all, apart from carnival weeks."
      },
      {
        "q": "Is Nice cheaper than Cannes or Monaco?",
        "a": "Generally, yes. Nice has by far the largest choice of hotels and apartments, so there's more at every budget. Monaco is the most expensive place to stay on the coast, with Cannes and Saint-Tropez close behind in season. Menton and Antibes are often good value, and staying in one town while visiting another by train is a common way to save."
      },
      {
        "q": "Is there a tourist tax?",
        "a": "Yes. French towns charge a tourist tax (taxe de séjour) per adult per night, set locally and higher for higher-rated hotels. It's often added at the hotel rather than included in the price you see online, so check the booking conditions."
      },
      {
        "q": "How does booking through this page work?",
        "a": "We don't sell rooms ourselves. The map and the \"See hotels\" buttons show offers from the main booking sites through our partner Stay22; you choose, book and pay on the booking site, under its own conditions. We may earn a commission when you book, at no extra cost to you."
      }
    ]
  },
  "articlesHub": {
    "intro": [
      "Articles about the French Riviera (Côte d'Azur), from Saint-Tropez and Cannes to Nice, Monaco and Menton: when to go and which festivals to catch, what to eat and drink, how a day on a yacht works, and where to go on a day trip — written to help you plan, with links to what's actually on."
    ],
    "cityGuidesHeading": "City guides"
  },
  "cityClimate": {
    "heading": "Weather {{inCity}} by month",
    "columns": {
      "month": "Month",
      "high": "Day °C",
      "low": "Night °C",
      "sea": "Sea °C",
      "rain": "Rainy days"
    },
    "note": "Best for swimming and boat trips: June to September, when the sea is 20 °C or warmer. Spring and autumn are milder and quieter — a good time for walking, day trips and wine tours.",
    "source": "Average daytime and night-time air temperatures and days with at least 1 mm of rain: Météo-France climate normals {{period}}, {{station}} station. Sea: approximate monthly average along the coast.",
    "stations": {
      "nice": "Nice airport",
      "villefranche": "Nice airport (the nearest)",
      "cannes": "Cannes",
      "antibes": "Antibes",
      "monaco": "Monaco",
      "menton": "Monaco (the nearest)",
      "sttropez": "Cogolin (the nearest)"
    },
    "months": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "inMonth": [
      "in January",
      "in February",
      "in March",
      "in April",
      "in May",
      "in June",
      "in July",
      "in August",
      "in September",
      "in October",
      "in November",
      "in December"
    ],
    "faq": {
      "byMonthQ": "What is the weather like {{inCity}} by month?",
      "byMonthA": "Winters are mild and summers hot and dry. Average daytime highs range from {{coldHigh}} °C {{coldMonth}} to {{hotHigh}} °C {{hotMonth}}, and nights from {{coldLow}} °C to {{hotLow}} °C. Rain is most frequent {{wetMonth}} (about {{wetDays}} rainy days) and rarest {{dryMonth}}.",
      "monthQ": "What is the weather like {{inCity}} {{month}}?",
      "monthA": "{{Month}}, daytime highs average {{high}} °C and nights {{low}} °C, with the sea at about {{sea}} °C. Expect around {{rain}} rainy days in the month.",
      "swimQ": "When can you swim in the sea {{inCity}}?",
      "swimA": "From June to September the sea is 20 °C or warmer, peaking at about 24 °C in August, and in October it is still around 20 °C. In winter it cools to about 13 °C — fine for a quick dip, but cold for most swimmers."
    }
  },
  "cityPages": {
    "nice": {
      "title": "Things to Do in Nice",
      "metaDescription": "Plan your visit to Nice: concerts, exhibitions and festivals along the Promenade des Anglais, plus the best tours and day trips from the Riviera's capital.",
      "intro": [
        "Nice is the beating heart of the French Riviera — a city where the Alps meet the Mediterranean along the sweeping curve of the Promenade des Anglais. Spend your mornings wandering the pastel façades and market stalls of Vieux Nice, then your afternoons on the pebbled beaches or exploring world-class collections at the Musée Matisse and MAMAC.",
        "Beyond the postcard views, Nice hosts a packed calendar of concerts, exhibitions and festivals year-round, from the exuberant Nice Carnival in February to open-air jazz in summer. It's also the easiest base for exploring the rest of the Côte d'Azur, with Cannes, Monaco and the hill villages of the Alpes-Maritimes all within an hour's reach."
      ]
    },
    "cannes": {
      "title": "Things to Do in Cannes",
      "metaDescription": "From the red carpet on La Croisette to the old town of Le Suquet: discover Cannes' best events, tours and experiences on the French Riviera.",
      "intro": [
        "Cannes is best known for eleven days in May, when the world's film industry descends on the Palais des Festivals and the red carpet lines La Croisette. But the city's glamour runs year-round — this is where superyachts moor beside Belle Époque hotels, and where a morning market in Le Suquet's old town gives way to an afternoon of boutique-lined boulevards.",
        "Outside festival season, Cannes still delivers a steady calendar of exhibitions, concerts and gourmet events, plus easy boat trips to the pine-covered Îles de Lérins just offshore. It's a compact, walkable city — and one of the best-connected bases for day trips along the coast."
      ]
    },
    "monaco": {
      "title": "Things to Do in Monaco",
      "metaDescription": "Casino nights, Grand Prix thrills and Belle Époque grandeur: plan your visit to Monaco with the Riviera's best events, tours and experiences.",
      "intro": [
        "Barely two square kilometres, Monaco packs in more glamour per acre than almost anywhere on earth. The Casino de Monte-Carlo and the Prince's Palace anchor a principality built on hairpin turns and clifftop terraces, and for one weekend each May, its streets become the Monaco Grand Prix circuit — one of Formula 1's most demanding races.",
        "When the engines are quiet, Monaco offers world-class exhibitions, the Oceanographic Museum's aquarium, and a harbour lined with some of the largest yachts afloat. It's an easy day trip from Nice or Menton, and a natural stop on any tour of the eastern Riviera."
      ]
    },
    "antibes": {
      "title": "Things to Do in Antibes",
      "metaDescription": "Picasso's old studio, medieval ramparts and the Marché Provençal: discover the best events and experiences in Antibes and Juan-les-Pins.",
      "intro": [
        "Antibes wears its history on its ramparts — a fortified old town built by the Greeks and rebuilt by Vauban, wrapped around a harbour that once sheltered Picasso, who painted some of his most joyful work here in what's now the Musée Picasso. The daily Marché Provençal is one of the best food markets on the coast.",
        "Just around the cape, Juan-les-Pins adds a livelier side with its jazz festival and beach clubs, while Cap d'Antibes offers some of the Riviera's most scenic coastal walks. Between the old town's galleries and the modern marina's restaurants, Antibes rewards slow exploring."
      ]
    },
    "sttropez": {
      "title": "Things to Do in Saint-Tropez",
      "metaDescription": "From the Old Port to Pampelonne beach: plan your trip to Saint-Tropez with the Riviera's best events, boat tours and experiences.",
      "intro": [
        "Once a quiet fishing village, Saint-Tropez has spent six decades as the Riviera's byword for glamour — its Old Port still lined with pastel houses, now backed by yachts instead of fishing boats. The Place des Lices hosts a market and a permanent game of pétanque, while the Citadel above town gives the best view over the bay.",
        "South of the village, the long sweep of Pampelonne beach is where Saint-Tropez's beach-club culture was born, and still draws a crowd every summer. Come for a day trip by boat from Sainte-Maxime or Nice, or stay long enough to see the port at both sunrise and sunset."
      ]
    },
    "menton": {
      "title": "Things to Do in Menton",
      "metaDescription": "Lemon groves, Italian light and the Fête du Citron: discover events, tours and experiences in Menton, the Riviera's quietest gem.",
      "intro": [
        "Tucked against the Italian border, Menton trades the Riviera's bustle for pastel-coloured calm — an old town of steep, narrow streets climbing to a Baroque basilica, and a seafront lined with the lemon and citrus gardens that give the town its nickname, the 'Pearl of France'.",
        "Every February, Menton's famous Fête du Citron transforms the seafront gardens into giant sculptures built entirely from citrus fruit. The rest of the year, its gardens, small museums and easy walking trails into the hills make it one of the Riviera's most relaxed bases — and a short hop from both Monaco and the Italian border towns."
      ]
    },
    "villefranche": {
      "title": "Things to Do in Villefranche-sur-Mer",
      "metaDescription": "One of the Mediterranean's deepest natural harbours, a Cocteau-decorated chapel and a colourful old town: discover Villefranche-sur-Mer.",
      "intro": [
        "Villefranche-sur-Mer sits on one of the deepest natural harbours in the Mediterranean, which is why cruise ships now anchor where fishing boats once did. Its old town is a tight maze of covered stairways and pastel buildings running straight down to the water, watched over by the 16th-century Citadelle Saint-Elme.",
        "Don't miss the small waterfront Chapelle Saint-Pierre, decorated inside by Jean Cocteau, or the view from Cap Ferrat's coastal path just next door. It's one of the smallest towns on this list, but its beach and harbourside restaurants make it an easy, low-key base for exploring the whole bay."
      ]
    }
  },
  "features": {
    "notifications": {
      "title": "Notifications",
      "desc": "Get notified about the events that interest you"
    },
    "favorites": {
      "title": "Favorites",
      "desc": "Save events and build your own personal calendar"
    },
    "map": {
      "title": "Event map",
      "desc": "Find events near you on the interactive map"
    },
    "tickets": {
      "title": "Buy tickets",
      "desc": "Buy tickets directly from trusted partners"
    }
  },
  "wineTours": {
    "region": {
      "title": "Wine Tours on the French Riviera",
      "seoTitle": "Wine Tours on the French Riviera & Provence",
      "metaDescription": "Compare the best-rated wine tours and tastings from Nice, Cannes, Saint-Tropez, Antibes and Monaco: Côtes de Provence rosé, Bellet and Bandol vineyards.",
      "intro": [
        "The French Riviera sits on the doorstep of Provence, the world's leading rosé region. Within an hour of the coast you can be tasting in the vineyards of the Côtes de Provence — and Nice even has its own tiny appellation, Bellet, planted on the hills above the city.",
        "Below are the best-rated wine tours and tastings departing from the Riviera's main towns — from two-hour tasting workshops to full-day private tours with a driver, so nobody has to drive after the tasting. Every tour is booked securely on Viator, where you'll find availability, pickup details and the cancellation policy."
      ],
      "listHeading": "Top-rated wine tours on the Riviera",
      "privateHeading": "Private wine tours on the French Riviera",
      "sections": [
        {
          "heading": "Wine regions near the Riviera",
          "paragraphs": [
            "Bellet is one of France's smallest appellations: a handful of family estates on the hills above Nice, overlooking the Var valley. Its whites are made mainly from Rolle (Vermentino), its reds and rosés from rare local grapes such as Braquet and Folle Noire that are hardly grown anywhere else.",
            "Côtes de Provence is Provence's largest appellation, and nearly all of its wine is rosé — dry and pale, from Grenache, Cinsault and Syrah. Its vineyards run from the Saint-Tropez peninsula (Ramatuelle, Gassin, La Croix-Valmer) inland across the Var to Les Arcs-sur-Argens, Lorgues and La Motte. Further west, near Toulon, Bandol is known for deep, age-worthy reds made from Mourvèdre."
          ]
        },
        {
          "heading": "What a wine tour looks like",
          "paragraphs": [
            "The shortest format is a tasting workshop in town: in a couple of hours a sommelier explains how to taste and pours a selection of Provence wines. A half-day tour usually visits one or two estates — from Nice, most often in Bellet. A full day takes in two or three wineries, lunch in Provence and often a stop in a hilltop village such as Saint-Paul-de-Vence.",
            "At the estate you usually walk the vines and see the cellar, then taste several wines, sometimes with cheese or local snacks — and you can buy the bottles you liked on the spot. Many small estates only receive visitors by appointment, which is why a tour with a set schedule is the easiest way in."
          ]
        }
      ]
    },
    "cities": {
      "nice": {
        "title": "Wine Tours from Nice",
        "seoTitle": "Wine Tours from Nice — Bellet & Provence Tastings",
        "metaDescription": "Best-rated wine tours from Nice: the Bellet vineyards above the city, Côtes de Provence rosé estates and private day trips with hotel pickup.",
        "intro": [
          "Nice is one of the few French cities with a wine appellation inside its own limits: AOC Bellet, a handful of family estates on the hills west of the centre, around 20 minutes' drive away. Its whites are made mainly from Rolle (Vermentino), alongside rare local grapes such as Braquet and Folle Noire that you'll hardly find anywhere else.",
          "For a full day out, tours from Nice also head west into the Var to the rosé estates of the Côtes de Provence, often combined with a hilltop village such as Saint-Paul-de-Vence. Most include hotel pickup, so you can taste freely."
        ],
        "listHeading": "Top-rated wine tours from Nice",
        "privateHeading": "Private wine tours from Nice"
      },
      "cannes": {
        "title": "Wine Tours from Cannes",
        "seoTitle": "Wine Tours from Cannes — Provence Wine Tastings",
        "metaDescription": "Best-rated wine tours and wine tastings from Cannes: Côtes de Provence rosé estates, private day tours with a driver, and Grasse & hilltop village trips.",
        "intro": [
          "From Cannes, the rosé country of the Côtes de Provence is about an hour's drive west, around Les Arcs-sur-Argens, Lorgues and La Motte. Wine tours from Cannes usually visit two or three estates — often including a château — with guided tastings of rosé, white and red.",
          "Shorter options pair a local tasting with Grasse's perfumeries and the Provençal hilltop villages behind the coast. And just offshore, the monks of Lérins Abbey on the Île Saint-Honorat still tend their own vineyard — a short boat ride from the old port."
        ],
        "listHeading": "Top-rated wine tours from Cannes",
        "privateHeading": "Private wine tours from Cannes"
      },
      "sttropez": {
        "title": "Wine Tours in Saint-Tropez",
        "seoTitle": "Wine Tours in Saint-Tropez — Rosé Vineyard Tastings",
        "metaDescription": "Best-rated wine tours in Saint-Tropez: Côtes de Provence rosé estates in Ramatuelle, Gassin and La Croix-Valmer, on private or small-group tastings.",
        "intro": [
          "Saint-Tropez sits in the middle of rosé country. Vineyards cover the peninsula around Ramatuelle, Gassin and La Croix-Valmer, and some of Provence's best-known rosé estates are less than 20 minutes' drive from the port.",
          "Choose between shared small-group tours, private tours of the peninsula's estates, or dinner among the vines. Summer is the busiest season; from late August through September you may see the harvest under way."
        ],
        "listHeading": "Top-rated wine tours in Saint-Tropez",
        "privateHeading": "Private wine tours in Saint-Tropez"
      },
      "antibes": {
        "title": "Wine Tours from Antibes",
        "seoTitle": "Wine Tours from Antibes — Provence Tastings",
        "metaDescription": "Best-rated wine tours from Antibes and Juan-les-Pins: private Provence wine days, Côtes de Provence rosé estates and tastings with local produce.",
        "intro": [
          "Halfway between Nice and Cannes, Antibes is a convenient base for a wine day: the Bellet vineyards above Nice are about 30 minutes away, and the rosé estates of the Côtes de Provence roughly an hour west.",
          "Tours from Antibes range from a Provençal market walk with a tasting to full-day private tours of the Var's vineyards with a driver-guide and hotel pickup in Antibes or Juan-les-Pins."
        ],
        "listHeading": "Top-rated wine tours from Antibes",
        "privateHeading": "Private wine tours from Antibes"
      },
      "menton": {
        "title": "Wine Tastings & Wine Tours in Menton",
        "seoTitle": "Wine Tastings & Wine Tours in Menton",
        "metaDescription": "Wine tastings and wine tours in Menton: small-group tasting workshops in town, the Bellet vineyards near Nice and Ligurian wines just over the Italian border.",
        "intro": [
          "Menton, on the Italian border, is best known for its lemons — but it makes a good base for wine too. In town, small-group tasting workshops introduce the wines of Provence and the neighbouring Italian Riviera without leaving the old quarter.",
          "Further afield, the Bellet vineyards above Nice are around 45 minutes away, and just across the border in Liguria the red Rossese di Dolceacqua is made in the hills behind Ventimiglia."
        ],
        "listHeading": "Top-rated wine tastings & tours in Menton",
        "privateHeading": "Private wine tours from Menton"
      },
      "monaco": {
        "title": "Wine Tours from Monaco",
        "seoTitle": "Wine Tours from Monaco — Provence & Bellet Day Trips",
        "metaDescription": "Wine tours from Monaco and Monte-Carlo: private day trips to Côtes de Provence rosé estates, the Bellet vineyards above Nice and Ligurian wine country.",
        "intro": [
          "Monaco has no wine appellation of its own, but it's a comfortable starting point for a wine day: the Bellet appellation above Nice is around 40 minutes away, and the Italian border — with the Ligurian vineyards of Dolceacqua beyond it — is closer still.",
          "For the full Provence experience, private tours from Monaco head west to the rosé estates of the Côtes de Provence, usually with pickup at your hotel or yacht berth and a driver-guide for the day."
        ],
        "listHeading": "Top-rated wine tours from Monaco",
        "privateHeading": "Private wine tours from Monaco"
      },
      "villefranche": {
        "title": "Wine Tours from Villefranche-sur-Mer",
        "seoTitle": "Wine Tours from Villefranche-sur-Mer",
        "metaDescription": "Wine tours from Villefranche-sur-Mer, including half-day tastings that fit cruise schedules: the Bellet vineyards above Nice and Provence rosé estates.",
        "intro": [
          "Villefranche-sur-Mer is one of the Mediterranean's busiest cruise-ship anchorages, and a wine tasting is one of the easiest shore excursions from the harbour: the Bellet vineyards above Nice are about 30 minutes away, so a half-day tour fits comfortably into a port call.",
          "With a full day, tours continue west to the rosé estates of the Côtes de Provence. If you're arriving by ship, check the pickup point and return time on each listing."
        ],
        "listHeading": "Top-rated wine tours from Villefranche-sur-Mer",
        "privateHeading": "Private wine tours from Villefranche-sur-Mer"
      }
    },
    "faq": [
      {
        "q": "Which wine regions can I visit from the French Riviera?",
        "a": "The closest is Bellet, a small appellation on the hills just west of Nice. About an hour west of Cannes lie the rosé estates of the Côtes de Provence, around Les Arcs-sur-Argens, Lorgues and the Saint-Tropez peninsula. Some full-day tours go further, to Bandol near Toulon, known for its Mourvèdre-based reds."
      },
      {
        "q": "What kind of wine will I taste?",
        "a": "Mostly rosé — it's by far the main colour of the Côtes de Provence. Expect crisp whites from Rolle (Vermentino) too, and structured reds in Bandol and Bellet. A typical estate visit includes a tasting of three to five wines."
      },
      {
        "q": "How much does a wine tour on the Riviera cost?",
        "a": "The most affordable options are tasting workshops and shared small-group tours, priced per person. Private day tours with your own driver-guide cost considerably more and are often priced per group rather than per person. Each tour shows its current starting price."
      },
      {
        "q": "Is a private wine tour worth it?",
        "a": "For a couple, a shared small-group tour is usually the cheaper option. A private tour makes sense for families and groups, for a special occasion, or if you want to pick the estates yourself: you get your own driver-guide, pickup where you're staying and a flexible schedule. Private tours are listed separately on each page."
      },
      {
        "q": "Do I need a car?",
        "a": "No. Most tours include transport and pickup from your hotel, the port or a central meeting point, so everyone can taste. France's drink-driving limit is 0.5 g/l — lower than in the UK or the US — so a tour with a driver is the sensible choice."
      },
      {
        "q": "When is the best time for a wine tour?",
        "a": "Estates welcome visitors year-round, but spring to autumn is the liveliest period, with the harvest from late August into September. Many smaller estates close on Sundays and some reduce their hours in winter, so check each tour's availability."
      },
      {
        "q": "How do I book, and can I cancel?",
        "a": "Tours are booked on Viator, which handles payment and confirmation. Many offer free cancellation up to 24 hours before the start — check the policy on each listing before you book."
      }
    ],
    "citiesHeading": "Wine tours by departure city",
    "cityLinksHeading": "Wine tours by town",
    "groupHeading": "Group tours & tastings",
    "privateIntro": "On a private tour the car, the driver-guide and the itinerary are yours alone: most pick you up at your hotel, villa or cruise port, and you choose the estates and the pace. They're often priced per group rather than per person — check each listing — so they work out best for families and groups of friends.",
    "compare": {
      "note": "Ranked by rating and number of reviews. Prices are the current starting price on Viator.",
      "tour": "Tour",
      "from": "Departs from",
      "duration": "Duration",
      "format": "Format",
      "rating": "Reviews",
      "price": "Price from",
      "private": "Private",
      "group": "Group"
    },
    "allCities": "Whole Riviera",
    "stats_one": "{{count}} wine tour · from {{price}}",
    "stats_other": "{{count}} wine tours · from {{price}}",
    "faqHeading": "Wine tours: frequently asked questions",
    "loading": "Loading wine tours…",
    "empty": "No wine tours found yet.",
    "allTours": "Browse all tours & experiences"
  },
  "boatsHub": {
    "intro": [
      "Motorboats, RIBs, motor yachts, sailboats, catamarans and licence-free boats for rent in the ports of the French Riviera (Côte d'Azur), from Saint-Tropez and Cannes to Antibes, Nice, Monaco and Menton. Rent for a half-day, a day or longer, with a skipper or on your own: each listing shows the boat type, port, day rate and a link to book on Click&Boat."
    ],
    "sections": [
      {
        "heading": "Where to go by boat",
        "paragraphs": [
          "From Cannes, the Lérins Islands — Sainte-Marguerite and Saint-Honorat — are a short crossing away, and to the west the red rocks of the Esterel hide quiet coves. From Antibes and Juan-les-Pins, boats round Cap d'Antibes; from Nice and Villefranche-sur-Mer, the sheltered bay of Villefranche and the coves of Cap Ferrat. From Saint-Tropez, the classic day out is Pampelonne beach and the Gulf of Saint-Tropez, and from Monaco the coast east towards Cap Martin and Menton."
        ]
      },
      {
        "heading": "Which boat to choose",
        "paragraphs": [
          "Licence-free boats have small engines and suit short, easy trips close to the shore. RIBs are fast and nimble — the usual choice for reaching islands and coves. Motorboats are the all-round option for a family day at sea, while motor yachts are mostly rented with a skipper for groups and occasions. Sailboats and catamarans are for sailing; a catamaran is stable and roomy, which makes it popular for longer days and for groups."
        ]
      },
      {
        "heading": "Good to know before you go",
        "paragraphs": [
          "In France, driving a boat with an engine over 6 hp requires a boating licence (the permis côtier covers coastal waters); without one, choose a licence-free boat or a skipper. Within 300 metres of the shore speed is limited to 5 knots, and beaches have marked swimming zones boats must keep out of. The sea is usually calmest in the morning — plan crossings early and check the forecast with the owner."
        ]
      }
    ],
    "citiesHeading": "Boat rental by town"
  },
  "boatRental": {
    "cities": {
      "nice": {
        "title": "Boat Rental in Nice",
        "seoTitle": "Boat Rental in Nice — Motorboats, RIBs & Yachts",
        "inCity": "in Nice"
      },
      "cannes": {
        "title": "Boat Rental in Cannes",
        "seoTitle": "Boat Rental in Cannes — Yachts, Motorboats & RIBs",
        "inCity": "in Cannes"
      },
      "antibes": {
        "title": "Boat Rental in Antibes",
        "seoTitle": "Boat Rental in Antibes & Juan-les-Pins",
        "inCity": "in Antibes"
      },
      "villefranche": {
        "title": "Boat Rental in Villefranche-sur-Mer",
        "seoTitle": "Boat Rental in Villefranche-sur-Mer",
        "inCity": "in Villefranche-sur-Mer"
      },
      "monaco": {
        "title": "Boat Rental in Monaco",
        "seoTitle": "Boat & Yacht Rental in Monaco",
        "inCity": "in Monaco"
      },
      "menton": {
        "title": "Boat Rental in Menton",
        "seoTitle": "Boat Rental in Menton — With or Without Skipper",
        "inCity": "in Menton"
      },
      "sttropez": {
        "title": "Boat Rental in Saint-Tropez",
        "seoTitle": "Boat Rental in Saint-Tropez — Yachts, RIBs & Motorboats",
        "inCity": "in Saint-Tropez"
      }
    },
    "metaDescription_one": "Rent a boat {{inCity}}: {{count}} boat from {{price}}/day, with or without a skipper. Compare and book on Click&Boat.",
    "metaDescription_other": "Rent a boat {{inCity}}: {{count}} boats from {{price}}/day — motorboats, RIBs, yachts and catamarans, with or without a skipper. Compare and book on Click&Boat.",
    "stats_one": "{{count}} boat · from {{price}}/day",
    "stats_other": "{{count}} boats · from {{price}}/day",
    "ratingStat": "average rating {{rating}}/5",
    "typesHeading": "Boat types and prices",
    "typeRow_one": "{{count}} boat · from {{price}}",
    "typeRow_other": "{{count}} boats · from {{price}} · typically {{median}}/day",
    "portsHeading": "Departure ports",
    "topHeading": "Top-rated boats {{inCity}}",
    "allHeading": "All boats for rent {{inCity}}",
    "citiesHeading": "Boat rental in other Riviera towns",
    "allBoats": "All yacht & boat rentals on the Riviera",
    "faqHeading": "Renting a boat {{inCity}}: frequently asked questions",
    "listSeparator": ", ",
    "loading": "Loading boats…",
    "empty": "No boats found.",
    "typePlural": {
      "Motorboat": "motorboats",
      "Sailboat": "sailboats",
      "Catamaran": "catamarans",
      "RIB": "RIBs",
      "Motor yacht": "motor yachts",
      "Houseboat": "houseboats",
      "Boat without licence": "licence-free boats",
      "Jet ski": "jet skis",
      "Sailing yacht": "sailing yachts",
      "other": "other boats"
    },
    "faq": {
      "priceQ": "How much does it cost to rent a boat {{inCity}}?",
      "priceA": "Day rates {{inCity}} start at {{min}}, and half of the listed boats cost {{median}} a day or less. By type: {{list}}. Fuel, a skipper and extras are usually charged separately — each listing on Click&Boat shows exactly what is included.",
      "typePrice": "{{type}} from {{price}}",
      "licenceQ": "Can I rent a boat without a licence {{inCity}}?",
      "licenceYesA_one": "Yes — {{count}} licence-free boat is listed {{inCity}}, from {{price}} a day: a small, low-powered boat you can drive without a permit. Any other boat can be booked with a skipper, and then no licence is needed either.",
      "licenceYesA_other": "Yes — {{count}} licence-free boats are listed {{inCity}}, from {{price}} a day: small, low-powered boats you can drive without a permit. Any other boat can be booked with a skipper, and then no licence is needed either.",
      "licenceNoA": "No licence-free boats are listed {{inCity}} right now, but many boats can be booked with a skipper, in which case you need no licence. To drive a motorboat yourself in France you need the coastal licence (permis côtier) for engines over 6 hp.",
      "portsQ": "Where do boat rentals {{inCity}} depart from?",
      "portsA": "Boats listed {{inCity}} depart from {{list}}. The exact meeting point is shown on each listing.",
      "typesQ": "What kind of boat can I rent {{inCity}}?",
      "typesA": "The fleet {{inCity}} currently includes {{list}}. Motorboats and RIBs suit a half or full day along the coast, on your own or with a skipper; catamarans and motor yachts are usually rented with a skipper, for groups."
    },
    "detailLink": "Renting a boat {{inCity}}: prices, licence and departure ports",
    "showAllType": "Show all {{count}} {{type}}",
    "showFewer": "Show fewer",
    "typeChipsHeading": "Boat types {{inCity}}",
    "typeMeta": "{{countText}} for rent {{inCity}} from {{price}}/day, typically {{median}}. Compare day rates and departure ports, then book on Click&Boat.",
    "typeStats": "{{countText}} · from {{price}}/day · typically {{median}}/day",
    "typePricesHeading": "Day rates",
    "typeTopHeading": "Top-rated {{plural}} {{inCity}}",
    "typeAllHeading": "All {{plural}} for rent {{inCity}}",
    "typeOtherTypesHeading": "Other boats {{inCity}}",
    "typeOtherCitiesHeading": "{{pluralCap}} in other Riviera towns",
    "typeFaqHeading": "{{title}}: frequently asked questions",
    "typePriceA": "Day rates for {{plural}} {{inCity}} start at {{min}}, and half of them cost {{median}} a day or less. By price: {{bands}}. Fuel, a skipper and extras are usually charged separately — each listing on Click&Boat shows exactly what is included.",
    "typePortsQ": "Where do {{plural}} {{inCity}} depart from?",
    "typePortsA": "The {{plural}} listed {{inCity}} depart from {{list}}. The exact meeting point is shown on each listing.",
    "typeDetailLink": "{{title}}: prices and departure ports",
    "typePages": {
      "motorboat": {
        "title": "Motorboat rental {{inCity}}",
        "seoTitle": "Motorboat Rental {{inCity}} — With or Without Skipper",
        "plural": "motorboats",
        "count_one": "{{count}} motorboat",
        "count_other": "{{count}} motorboats",
        "intro": "Motorboats are the most popular way to spend a day on the water {{inCity}}: easy to handle, fast enough to reach the nearby bays and islands, and available with or without a skipper. Below are all the motorboats listed {{inCity}} on Click&Boat, with their day rates and departure ports.",
        "priceQ": "How much does it cost to rent a motorboat {{inCity}}?",
        "licenceQ": "Do I need a licence to rent a motorboat {{inCity}}?",
        "licenceA": "To drive a motorboat yourself in France you need the coastal licence (permis côtier) for any engine over 6 hp, which covers almost every boat here. Without one, book the boat with a skipper — many owners offer it — or choose a licence-free boat."
      },
      "rib": {
        "title": "RIB rental {{inCity}}",
        "seoTitle": "RIB Rental {{inCity}} — Semi-Rigid Boats by the Day",
        "plural": "RIBs",
        "count_one": "{{count}} RIB",
        "count_other": "{{count}} RIBs",
        "intro": "RIBs (rigid inflatable boats) are light, fast and stable — the classic choice for a day of swimming stops from cove to cove {{inCity}}. Below are all the RIBs listed {{inCity}} on Click&Boat, with their prices and departure ports.",
        "priceQ": "How much does it cost to rent a RIB {{inCity}}?",
        "licenceQ": "Do I need a licence to rent a RIB {{inCity}}?",
        "licenceA": "Most RIBs have engines well over 6 hp, so driving one yourself requires the French coastal licence (permis côtier) or an equivalent. Without a licence, book a RIB with a skipper."
      },
      "yacht": {
        "title": "Yacht rental {{inCity}}",
        "seoTitle": "Yacht Rental {{inCity}} — Day Charter With Skipper",
        "plural": "yachts",
        "count_one": "{{count}} yacht",
        "count_other": "{{count}} yachts",
        "intro": "A motor or sailing yacht is the way to spend a day at sea {{inCity}} in comfort: a shaded deck, a cabin and room for a group, usually with a professional skipper on board. Below are all the yachts listed {{inCity}} on Click&Boat, with their day rates and departure ports.",
        "priceQ": "How much does it cost to rent a yacht for a day {{inCity}}?",
        "licenceQ": "Do I need a licence to rent a yacht {{inCity}}?",
        "licenceA": "Usually not: yachts are almost always rented with a skipper or crew, who handle the boat. Fuel, the skipper and extras are often charged on top of the day rate — each listing shows what is included."
      },
      "sailboat": {
        "title": "Sailboat rental {{inCity}}",
        "seoTitle": "Sailboat Rental {{inCity}} — With or Without Skipper",
        "plural": "sailboats",
        "count_one": "{{count}} sailboat",
        "count_other": "{{count}} sailboats",
        "intro": "Renting a sailboat {{inCity}} means a quiet day under sail along the coast — with a skipper if you just want to enjoy it, or on your own if you are an experienced sailor. Below are all the sailboats listed {{inCity}} on Click&Boat, with their prices and departure ports.",
        "priceQ": "How much does it cost to rent a sailboat {{inCity}}?",
        "licenceQ": "Do I need a licence to rent a sailboat {{inCity}}?",
        "licenceA": "Not if you book it with a skipper. To sail one yourself, owners ask for proof of sailing experience, and the French coastal licence (permis côtier) is required to use an engine over 6 hp."
      },
      "catamaran": {
        "title": "Catamaran rental {{inCity}}",
        "seoTitle": "Catamaran Rental {{inCity}} — Day Charter With Skipper",
        "plural": "catamarans",
        "count_one": "{{count}} catamaran",
        "count_other": "{{count}} catamarans",
        "intro": "Catamarans are stable, spacious and ideal for groups: two hulls, a wide deck and trampoline nets for sunbathing between swims. Most catamarans {{inCity}} are rented by the day with a skipper. Below are all of them on Click&Boat, with their day rates and departure ports.",
        "priceQ": "How much does it cost to rent a catamaran {{inCity}}?",
        "licenceQ": "Do I need a licence to rent a catamaran {{inCity}}?",
        "licenceA": "Not if you book it with a skipper, which is how most catamarans are rented. To take one out yourself, the owner will ask for proof of experience, and the French coastal licence (permis côtier) is required for engines over 6 hp."
      },
      "no-licence": {
        "title": "Licence-free boat rental {{inCity}}",
        "seoTitle": "Boat Rental Without a Licence {{inCity}}",
        "plural": "licence-free boats",
        "count_one": "{{count}} licence-free boat",
        "count_other": "{{count}} licence-free boats",
        "intro": "No boat licence? Licence-free boats have an engine of 6 hp or less, so in France anyone can drive one after a short briefing from the owner. They are slower than other boats and stay close to the shore — perfect for a few hours of swimming stops {{inCity}}. Below are all of them on Click&Boat, with their prices and departure ports.",
        "priceQ": "How much does it cost to rent a boat without a licence {{inCity}}?",
        "licenceQ": "Can I really drive these boats {{inCity}} without a licence?",
        "licenceA": "Yes. In France, a boat with an engine of 6 hp (4.5 kW) or less can be driven without a licence; the owner gives you a briefing before you set off. Any bigger boat can also be booked with a skipper, and then no licence is needed either."
      }
    }
  },
  "eventsHub": {
    "intro": [
      "Upcoming concerts, theatre, stand-up, shows and festivals on the French Riviera (Côte d'Azur) in one place — from Nice and Cannes to Monaco, Antibes and Menton. The listings are updated every day: each event shows its dates, venue, starting price and a link to buy tickets from the official seller."
    ],
    "sections": [
      {
        "heading": "The Riviera's year in events",
        "paragraphs": [
          "The year opens with the Monte-Carlo International Circus Festival in January. February brings the Nice Carnival and the Menton Lemon Festival, the two best-known winter celebrations in the south of France. In May Cannes hosts its film festival, and in May or June Monaco stages its Formula 1 Grand Prix.",
          "In summer the Riviera moves outdoors: Nice Jazz Festival and Jazz à Juan in Juan-les-Pins (Antibes) in July, and an international fireworks competition over the Bay of Cannes on summer evenings. From autumn to spring it's the season of theatres, opera houses and concert halls — when the listings carry the most plays, stand-up, ballet and classical music."
        ]
      },
      {
        "heading": "Where concerts and shows take place",
        "paragraphs": [
          "Big touring concerts and shows play the Palais Nikaïa arena in Nice and the Palais des Festivals in Cannes. Monaco's main stages are the Opéra de Monte-Carlo and the Grimaldi Forum; in Nice, the Opéra de Nice and the Théâtre National de Nice. Stand-up, smaller plays and concerts fill theatres, clubs and casinos in every town along the coast — each event page gives the exact venue."
        ]
      },
      {
        "heading": "How to buy tickets",
        "paragraphs": [
          "Open an event to see all its dates, the venue and the starting price. When a show runs several times, every date is on one page with its own Tickets button. Tickets are bought on the official seller's site, where you choose seats and pay — at the seller's own price."
        ]
      }
    ],
    "citiesHeading": "Events by town",
    "faqHeading": "French Riviera events: frequently asked questions",
    "faq": [
      {
        "q": "What is there to do on the French Riviera in the evening?",
        "a": "The listings cover concerts, theatre, stand-up, shows and festivals in Nice, Cannes, Monaco, Antibes, Menton and other Riviera towns. Each town also has its own page with every upcoming event grouped by category."
      },
      {
        "q": "When are the most events on?",
        "a": "The theatre and concert season runs from autumn to spring, when opera houses, theatres and concert halls are open. Summer is the time for festivals and open-air concerts, and January–February brings the Monaco circus festival, the Nice Carnival and the Menton Lemon Festival."
      },
      {
        "q": "Do I need to speak French?",
        "a": "Most plays and stand-up shows are in French. Concerts, opera, ballet, circus and music shows work without the language."
      },
      {
        "q": "How do I buy tickets?",
        "a": "Open an event and tap Get tickets, or the Tickets button next to the date you want — it takes you to the official seller's site, where you choose seats and pay."
      },
      {
        "q": "How often are the listings updated?",
        "a": "Every day: new events appear as soon as tickets go on sale, and past ones drop off the lists."
      }
    ]
  },
  "cityEvents": {
    "cities": {
      "nice": {
        "title": "Events in Nice",
        "seoTitle": "Events in Nice — Concerts, Theatre & Shows",
        "intro": [
          "Nice has the busiest cultural calendar on the Riviera. Palais Nikaïa, the arena on the western edge of the city, hosts the big touring concerts and shows, while the Opéra de Nice, the Théâtre National de Nice and a string of smaller stages such as the Théâtre Lino Ventura and the Théâtre de la Cité keep up a full programme of plays, stand-up and classical music from autumn to spring.",
          "The highlights of the year are the Carnival in February and the Nice Jazz Festival in July. Below is every upcoming event we list in Nice — the next few first, then all of them by type — each with its date, venue and a link to buy tickets."
        ]
      },
      "cannes": {
        "title": "Events in Cannes",
        "seoTitle": "Events in Cannes — Concerts, Shows & Festivals",
        "intro": [
          "Outside the film festival, most of Cannes' cultural life still happens at the Palais des Festivals on the Croisette: its Théâtre Debussy and Grand Auditorium stage theatre, concerts, ballet and comedy throughout the season. The Théâtre Croisette, the Théâtre Alexandre III and the Espace Miramar add smaller productions.",
          "In summer the bay becomes the stage for the Festival d'Art Pyrotechnique, the international fireworks competition. Below is every upcoming event we list in Cannes, with dates, venues and ticket links."
        ]
      },
      "monaco": {
        "title": "Events in Monaco",
        "seoTitle": "Events in Monaco — Opera, Shows & Concerts",
        "intro": [
          "For a city-state of two square kilometres, Monaco has an outsized cultural programme: opera and ballet at the Salle Garnier of the Opéra de Monte-Carlo, big shows and concerts at the Grimaldi Forum, and plays at the Théâtre Princesse Grace.",
          "Every January the International Circus Festival of Monte-Carlo fills the big top at Fontvieille, and spring brings the Grand Prix. Below is every upcoming event we list in Monaco, with dates, venues and ticket links."
        ]
      },
      "antibes": {
        "title": "Events in Antibes",
        "seoTitle": "Events in Antibes & Juan-les-Pins",
        "intro": [
          "Antibes and Juan-les-Pins pair old-town charm with a lively stage scene: Anthéa, the city's modern theatre, programmes plays, dance and concerts through the season, and the casinos and halls around town add comedy nights and tribute shows.",
          "Every July, Jazz à Juan — one of Europe's oldest jazz festivals — brings international names to the pine grove of La Pinède Gould. Below is every upcoming event we list in and around Antibes, with dates, venues and ticket links."
        ]
      },
      "menton": {
        "title": "Events in Menton",
        "seoTitle": "Events in Menton — Concerts, Theatre & Festivals",
        "intro": [
          "Menton's calendar is built around two big dates: the Fête du Citron in February, when the gardens fill with giant sculptures made of citrus fruit, and the Menton Music Festival in summer, with chamber music on the square in front of the Saint-Michel basilica.",
          "In between, the Palais de l'Europe, the Casino Barrière and the town's churches host concerts, plays and comedy. Below is every upcoming event we list in Menton, with dates, venues and ticket links."
        ]
      },
      "sttropez": {
        "title": "Events in Saint-Tropez",
        "seoTitle": "Events in Saint-Tropez — Concerts & Festivals",
        "intro": [
          "Saint-Tropez is liveliest in summer, when concerts and parties fill the port and the beaches of Pampelonne. The village's own traditions run all year: the Bravade in May, a centuries-old procession in honour of the town's patron saint, and Les Voiles de Saint-Tropez, the classic and modern yacht regatta at the turn of September and October.",
          "Off-season, concerts move indoors to the chapels and cultural venues of the village. Below is every upcoming event we list in Saint-Tropez, with dates, venues and ticket links."
        ]
      },
      "villefranche": {
        "title": "Events in Villefranche-sur-Mer",
        "seoTitle": "Events in Villefranche-sur-Mer",
        "intro": [
          "Villefranche-sur-Mer is a small harbour town, and its events are mostly local and seasonal: concerts and exhibitions in the Citadelle Saint-Elme, summer festivities on the waterfront and, in late winter, the Combat Naval Fleuri, when decorated boats parade across the bay and throw flowers to the crowd.",
          "For bigger concerts and shows, Nice is ten minutes away and Monaco about twenty. Below is every upcoming event we list in Villefranche, with dates, venues and ticket links."
        ]
      }
    },
    "metaDescription_one": "{{count}} upcoming event {{inCity}}: {{list}}. Dates, venues and tickets, updated daily.",
    "metaDescription_other": "{{count}} upcoming events {{inCity}}: {{list}}. Dates, venues and tickets, updated daily.",
    "stats_one": "{{count}} upcoming event",
    "stats_other": "{{count}} upcoming events",
    "priceStat": "tickets from {{price}}",
    "citiesHeading": "Events in other Riviera towns",
    "nextHeading": "Coming up next {{inCity}}",
    "allHeading": "All upcoming events {{inCity}}",
    "venuesHeading": "Venues",
    "faqHeading": "Events {{inCity}}: frequently asked questions",
    "showAll": "Show all {{count}}",
    "showFewer": "Show fewer",
    "allEvents": "All events on the French Riviera",
    "loading": "Loading events…",
    "empty": "No upcoming events found.",
    "listSeparator": ", ",
    "faq": {
      "whatQ": "What's on {{inCity}}?",
      "whatA": "We list {{count}} upcoming events {{inCity}}, from {{first}} to {{last}}: {{list}}. The list is refreshed every day as new dates go on sale.",
      "venuesQ": "Where do concerts and shows take place {{inCity}}?",
      "venuesA": "The venues with the most upcoming events {{inCity}} are {{list}}.",
      "ticketsQ": "How do I buy tickets for events {{inCity}}?",
      "ticketsA": "Open any event to see its date, time, venue and starting price, then follow the ticket link to book with the official seller.",
      "ticketsPriceA": "Tickets for events {{inCity}} start at {{price}}. Open any event to see its date, time, venue and starting price, then follow the ticket link to book with the official seller."
    }
  },
  "cityEventSlices": {
    "windows": {
      "today": {
        "title": "What's on {{inCity}} today",
        "when": "today",
        "label": "Today"
      },
      "this-weekend": {
        "title": "What's on {{inCity}} this weekend",
        "when": "this weekend",
        "label": "This weekend"
      },
      "this-week": {
        "title": "What's on {{inCity}} this week",
        "when": "in the next 7 days",
        "label": "This week"
      }
    },
    "categoryTitle": "{{category}} {{inCity}}",
    "categoryAnswer": "{{title}}: {{stats}}, {{range}}.",
    "windowCount_one": "{{count}} event {{inCity}} {{when}}",
    "windowCount_other": "{{count}} events {{inCity}} {{when}}",
    "range": "from {{first}} to {{last}}",
    "highlights": "Highlights: {{list}}.",
    "empty": "Nothing is listed {{inCity}} {{when}} yet.",
    "allHeading_one": "{{count}} event",
    "allHeading_other": "All {{count}} events",
    "updated": "Updated {{date}}",
    "browseHeading": "Browse events {{inCity}}",
    "allInCity": "All events",
    "loading": "Loading events…"
  },
  "toursHub": {
    "intro": [
      "Guided tours, day trips and experiences on the French Riviera (Côte d'Azur), departing from Nice, Cannes, Monaco, Antibes, Saint-Tropez, Menton and Villefranche-sur-Mer. Each tour shows its duration, traveller rating, starting price and a link to book on Viator."
    ],
    "sections": [
      {
        "heading": "Classic day trips on the Riviera",
        "paragraphs": [
          "The Riviera's best-known day trip follows the coast east from Nice: the medieval hilltop village of Èze, then Monaco and Monte-Carlo — the Prince's Palace and old town on the Rock, the casino and the Grand Prix circuit. Inland, tours head for Saint-Paul-de-Vence and its art galleries and the perfume town of Grasse; in summer, further into Provence for the lavender fields and the Gorges du Verdon.",
          "To the west, Saint-Tropez and the red cliffs of the Esterel make a full day out from Cannes or Nice, and to the east Menton is the last stop before the Italian border."
        ]
      },
      {
        "heading": "Tours by theme",
        "paragraphs": [
          "Beyond sightseeing, there are wine tastings in the Bellet and Côtes de Provence vineyards, food tours through markets and old towns, boat trips and snorkelling along the coast, and e-bike or walking tours of the towns. Private tours with a driver-guide are common here — the easiest way to fit several villages into one day, and a popular choice for cruise passengers docking at Villefranche-sur-Mer or Monaco."
        ]
      },
      {
        "heading": "How to book",
        "paragraphs": [
          "Tours are booked on Viator, which takes payment and sends the confirmation with the meeting point. Many day trips from Nice and Cannes include hotel pick-up, and many offer free cancellation up to 24 hours before the start — both are shown on each tour before you book."
        ]
      }
    ],
    "citiesHeading": "Tours by town",
    "faqHeading": "French Riviera tours: frequently asked questions",
    "faq": [
      {
        "q": "What are the best day trips on the French Riviera?",
        "a": "The classics are Èze and Monaco along the coast east of Nice, Saint-Paul-de-Vence and Grasse inland, and Saint-Tropez to the west. In summer, the lavender fields of Provence and the Gorges du Verdon are popular full-day trips."
      },
      {
        "q": "Group or private tour?",
        "a": "Small-group tours are the cheaper way to see the main sights. A private tour with a driver-guide costs more but sets its own pace and route — useful for families, for fitting in several villages, and for cruise passengers on a fixed timetable."
      },
      {
        "q": "Do I need a car?",
        "a": "No. Day trips include transport, and many pick up from hotels or a central meeting point in Nice or Cannes. Between the coastal towns, the regional train along the coast is an easy alternative."
      },
      {
        "q": "What language are the tours in?",
        "a": "Most group tours are guided in English, some also in French or other languages — the tour's languages are listed on Viator. For a guide in another language, a private tour is usually the easiest option."
      },
      {
        "q": "Can I cancel a booking?",
        "a": "Many tours offer free cancellation up to 24 hours before the start, but terms vary — they are shown on each tour before you book on Viator."
      },
      {
        "q": "How are tours ranked?",
        "a": "By traveller reviews: a rating counts for more the more reviews back it up, so a tour with hundreds of strong reviews ranks above a perfect score from a handful."
      }
    ]
  },
  "hubFilters": {
    "sort": "Sort",
    "reset": "Reset filters",
    "retry": "Try again",
    "loadError": "Couldn't load the results. Please try again.",
    "noResults": "Nothing matches these filters.",
    "sortOptions": {
      "recommended": "Recommended",
      "price_asc": "Price: low to high",
      "price_desc": "Price: high to low",
      "reviews": "Most reviewed",
      "newest": "Build year: newest first",
      "soonest": "Soonest first"
    },
    "sortBuildYear": "Build year",
    "duration": "Duration",
    "durationOptions": {
      "any": "Any duration",
      "short": "Up to 3 hours",
      "half": "3–6 hours",
      "full": "Over 6 hours"
    },
    "when": "When",
    "whenOptions": {
      "any": "Any date",
      "today": "Today",
      "tomorrow": "Tomorrow",
      "weekend": "This weekend",
      "week": "Next 7 days",
      "month": "Next 30 days"
    },
    "category": "Category",
    "format": "Private / group",
    "formatOptions": {
      "any": "Private & group",
      "group": "Group tours",
      "private": "Private tours"
    },
    "price": "Price",
    "pricePerDay": "Price per day",
    "priceAny": "Any price",
    "priceUnder": "Under {{price}}",
    "priceBetween": "{{min}}–{{max}}",
    "priceOver": "{{price}} and up",
    "boatType": "Boat type",
    "boatTypeOptions": {
      "any": "All boats",
      "motorboat": "Motorboats",
      "rib": "RIBs",
      "yacht": "Yachts",
      "sailboat": "Sailboats",
      "catamaran": "Catamarans",
      "nolicence": "No licence needed"
    },
    "toursCount_one": "{{count}} tour",
    "toursCount_other": "{{count}} tours",
    "boatsCount_one": "{{count}} boat",
    "boatsCount_other": "{{count}} boats",
    "eventsCount_one": "{{count}} event",
    "eventsCount_other": "{{count}} events"
  },
  "cityTours": {
    "cities": {
      "nice": {
        "title": "Tours & Excursions in Nice",
        "seoTitle": "Tours in Nice — Walking, Food & Bike Tours",
        "intro": [
          "Nice is the Riviera's main base for sightseeing. In town, the classic choices are a walking or food tour of Vieux Nice — socca, pissaladière and the Cours Saleya market — and bike or segway rides along the Promenade des Anglais up to Castle Hill.",
          "From Nice, half-day and full-day trips run east along the corniches to Èze and Monaco, west to Saint-Paul-de-Vence and Grasse, and inland as far as the Gorges du Verdon. Below are all the tours we list in Nice, grouped by length and ranked by traveller ratings."
        ]
      },
      "cannes": {
        "title": "Tours & Excursions in Cannes",
        "seoTitle": "Tours in Cannes — Island Excursions & Walking Tours",
        "intro": [
          "In Cannes, the most popular half-days are on the water: boats leave the old port for the Lérins Islands, where Île Sainte-Marguerite holds the fort of the Man in the Iron Mask and Île Saint-Honorat a working monastery with its own vineyard. On land, walking tours climb from the Croisette to Le Suquet, the old quarter.",
          "Cannes is also within easy reach of Grasse and its perfumeries, the red cliffs of the Esterel and the hilltop villages of the hinterland. Below are all the tours we list in Cannes, grouped by length and ranked by traveller ratings."
        ]
      },
      "monaco": {
        "title": "Tours & Excursions in Monaco",
        "seoTitle": "Tours in Monaco — Palace, Casino & Monte-Carlo",
        "intro": [
          "Monaco is compact enough to explore on foot: guided tours usually combine the Rock — the Prince's Palace, the cathedral and the Oceanographic Museum — with Monte-Carlo's casino square and a stretch of the Formula 1 street circuit.",
          "Monaco also makes a good base for trips along the coast to Èze and Menton, or across the border to the Italian Riviera. Below are all the tours we list in Monaco, grouped by length and ranked by traveller ratings."
        ]
      },
      "antibes": {
        "title": "Tours & Excursions in Antibes",
        "seoTitle": "Tours in Antibes — Old Town & Cap d'Antibes",
        "intro": [
          "Antibes pairs a walled old town with one of the Riviera's finest coastlines. Tours here cover the ramparts, the Provençal market and the Picasso Museum in the Château Grimaldi, or follow the coastal path around Cap d'Antibes.",
          "From Antibes it is a short drive to Saint-Paul-de-Vence, Grasse and Cannes, and boat trips leave from Port Vauban, one of Europe's largest yacht harbours. Below are all the tours we list in Antibes, grouped by length and ranked by traveller ratings."
        ]
      },
      "menton": {
        "title": "Tours & Excursions in Menton",
        "seoTitle": "Tours in Menton — Gardens, Old Town & Italy",
        "intro": [
          "Menton is the Riviera's garden town: its mild climate lets lemons and subtropical plants grow outdoors, and guided visits open gardens such as the Val Rahmeh and the Serre de la Madone. Walking tours climb the old town's stairways to the Saint-Michel basilica.",
          "Italy starts at the edge of town, so many tours from Menton cross the border to the Friday market in Ventimiglia, Dolceacqua or Sanremo, while others head west to Monaco and Èze. Below are all the tours we list in Menton, grouped by length and ranked by traveller ratings."
        ]
      },
      "sttropez": {
        "title": "Tours & Excursions in Saint-Tropez",
        "seoTitle": "Tours in Saint-Tropez — Boat Trips & Wine Tours",
        "intro": [
          "Saint-Tropez is best seen from the sea: boat tours cruise past the villas of the Baie des Canebiers and along the beaches of Pampelonne. On land, the port, the Citadel and the Place des Lices are made for a walking tour.",
          "The peninsula is also rosé country, so tastings in the vineyards of Ramatuelle and Gassin are among the most booked experiences, as are trips to the hilltop villages and the Îles d'Hyères. Below are all the tours we list in Saint-Tropez, grouped by length and ranked by traveller ratings."
        ]
      },
      "villefranche": {
        "title": "Tours & Excursions in Villefranche-sur-Mer",
        "seoTitle": "Tours in Villefranche-sur-Mer — Shore Excursions",
        "intro": [
          "Villefranche-sur-Mer is one of the Mediterranean's busiest cruise ports, so many of its tours are shore excursions timed to a ship's call: Monaco, Èze and Nice in a day, or a shorter loop of the Cap Ferrat peninsula and the Villa Ephrussi de Rothschild.",
          "If you are staying in town, the harbour, the Citadelle and the Rue Obscure — a covered medieval street — all feature on the walking tours. Below are all the tours we list in Villefranche, grouped by length and ranked by traveller ratings."
        ]
      }
    },
    "metaDescription_one": "Compare {{count}} tour {{inCity}}, from {{price}} per person — rated by travellers and booked on Viator.",
    "metaDescription_other": "Compare {{count}} tours and excursions {{inCity}}, from {{price}} per person: short walks, half-day and full-day trips, rated by travellers. Book on Viator.",
    "stats_one": "{{count}} tour",
    "stats_other": "{{count}} tours",
    "priceStat": "from {{price}} per person",
    "ratingStat": "average rating {{rating}}/5",
    "citiesHeading": "Tours in other Riviera towns",
    "durations": {
      "short": "Short tours (up to 3 hours)",
      "halfDay": "Half-day tours (3–6 hours)",
      "fullDay": "Full-day tours and day trips",
      "unknown": "Other experiences"
    },
    "faqHeading": "Tours {{inCity}}: frequently asked questions",
    "allTours": "All tours on the French Riviera",
    "loading": "Loading tours…",
    "empty": "No tours found.",
    "listSeparator": "; ",
    "faq": {
      "priceQ": "How much does a tour {{inCity}} cost?",
      "priceA": "Tours {{inCity}} start at {{min}} per person, and half of them cost {{median}} or less. Private tours and full-day trips with transport cost more — each listing on Viator shows exactly what is included.",
      "bestQ": "What are the best-rated tours {{inCity}}?",
      "bestA": "The highest-rated tours {{inCity}}, by traveller reviews: {{list}}.",
      "bestItem": "{{title}} ({{rating}}/5, {{reviews}} reviews)",
      "durationQ": "How long do tours {{inCity}} last?",
      "durationA": "Of the {{count}} tours we list {{inCity}}: {{list}}.",
      "bookQ": "How do I book a tour {{inCity}}?",
      "bookA": "Every tour here is booked on Viator, where you'll find live availability, the meeting or pickup point and the cancellation policy for your date."
    }
  },
  "footer": {
    "sisterSites": "Our other guides:",
    "tagline": "Events, tours, wine tastings and boat rentals across the French Riviera — Nice, Cannes, Monaco, Antibes, Saint-Tropez, Menton and Villefranche-sur-Mer.",
    "thingsToDo": "Things to do",
    "events": "Events",
    "tours": "Tours & excursions",
    "boatRental": "Boat rental",
    "wineTours": "Wine tours",
    "language": "Language",
    "disclosure": "Riviera To-Do is an independent guide. Some links are affiliate links: when you book through our partners (Viator, Fnac Spectacles, Click&Boat) we may earn a commission, at no extra cost to you."
  }
}
